import { icons } from 'src/assets/iconDef/icon.def';

export const demoapplicationMenuDef = [
  

{
        name: 'menu.project_summary',
        resource: 'project_summary',
        icon: 'fa fa-file-text-o',
        url: 'project_summary',
        auto_crud: true,
        check_permission:false,
        breadcrumb: 'project_summary'
}
]
